import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { REPORTING_DOCS_STATUS } from '@/helpers/reporting';
import { prettyDate } from '@/helpers/date';
import { DATE_FORMAT_DD_MM_YYYY } from '@/helpers/common';
import IconDone from './icon_done.svg';
import IconPending from './icon_pending.svg';
import IconWarn from './icon_warn.svg';
import r from '@/kit/RoundButton/button.module.scss';
import s from './index.module.scss';

export const ReportingStatus = ({ report }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('reporting');

  const status = report?.status_documents;

  const data = useMemo(() => {
    if (status === REPORTING_DOCS_STATUS.PASS) {
      return {
        icon: IconDone,
        title: t('reporting_upload_status.thank_you'),
        desc: t('reporting_upload_status.documents_received'),
        note: ({ next_due_date }) =>
          next_due_date
            ? t('reporting_upload_status.next_upload_date', {
                date: prettyDate(next_due_date, DATE_FORMAT_DD_MM_YYYY),
              })
            : '',
      };
    }

    if (status === REPORTING_DOCS_STATUS.REVIEW) {
      return {
        icon: IconPending,
        title: t('reporting_upload_status.processing_documents'),
        desc: t('reporting_upload_status.checking_coverage'),
      };
    }

    if (status === REPORTING_DOCS_STATUS.FAIL) {
      // TODO на первом этапе этот статус и статус REVIEW решили не показывать. Всегда будет PASS.
      return {
        icon: IconWarn,
        title: t('reporting_upload_status.attention_needed'),
        desc: t('reporting_upload_status.upload_and_try_again'),
      };
    }
  }, [status]);

  if (!data || !report) return null;

  return (
    <div className={s.content}>
      <img src={data.icon} alt="icon" width={24} height={24} />
      <div className={s.title}>{data.title}</div>
      <div className={classnames(s.desc, 'f-body-regular')}>{data.desc}</div>
      {data.note && <div className="f-body-regular">{data.note(report)}</div>}
      <div className={s.buttons}>
        <button
          type="button"
          className={classnames(r.yellow_large, s.button)}
          onClick={() => navigate(-1)}
        >
          {t('reporting_upload_status.done')}
        </button>
      </div>
    </div>
  );
};
